import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useConceptEntitlement } from "./ConceptEntitlementContext";
import { IS_STANDALONE } from "../../standalone/config";

/** 跳转「概念库」主页面；可选带上概念编码并自动搜索 */
export function useConceptNavigate(spaceId: string) {
  const navigate = useNavigate();
  const { conceptModule } = useConceptEntitlement();

  return useCallback(
    (conceptCode?: string) => {
      const code = conceptCode?.trim();
      const q = code ? `?concept=${encodeURIComponent(code)}&search=1` : "";
      if (IS_STANDALONE) {
        navigate(`/tactik/concept${q}`);
        return;
      }
      const routeKey = conceptModule?.spaceProductId?.trim();
      if (!routeKey) {
        return;
      }
      navigate(`/space/${spaceId}/${routeKey}${q}`);
    },
    [navigate, conceptModule?.spaceProductId, spaceId]
  );
}
